import { Component, OnInit } from '@angular/core';
import { PopupModel, PopupModelReturn } from '../../../AllTableClasses';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-notification-popup',
  templateUrl: './notification-popup.component.html',
  styleUrl: './notification-popup.component.scss'
})
export class NotificationPopupComponent implements OnInit {

  private destroy$ = new Subject<void>();

  popup: PopupModel | null = null;
  popupReturn: PopupModelReturn = new PopupModelReturn();

  constructor(private popupNotificationService: PopupNotificationService) { }

  ngOnInit(): void {
    this.popupNotificationService.notification$.pipe(takeUntil(this.destroy$)).subscribe((popup: PopupModel | null) => {
      this.popup = popup;
    });
  }

  ButtonClick() {
    if (this.popup?.Button) {
      this.popupReturn.Result = this.popup.Button.Result;
      this.popupNotificationService.ResolvePopup(this.popupReturn);
    }
  }

  AltButtonClick() {
    if (this.popup?.AltButton) {
      this.popupReturn.Result = this.popup.AltButton.Result;
      this.popupNotificationService.ResolvePopup(this.popupReturn);
    }
  }

  PopupEvent(event: string) {
    if(event === 'close') {
      this.popupReturn.Result = 'close';
      this.popupNotificationService.ResolvePopup(this.popupReturn);
    }

  }

  ngOnDestroy(): void {
    // Emit and complete the destroy$ Subject to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
